import { gridSizeMdLg12 } from '@/shared';

import { LoaderComponent, SingleTableBoxScene } from '@/shared/components/ui';
import { EstadoOrdenTrabajoCodigoEnum } from '@/shared/interfaces';
import { Grid, Typography } from '@mui/material';
import { useEffect } from 'react';
import CardComisionComponente from '../componente/CardComisionComponente';
import TablaInstalacionComponente from '../componente/TablaInstalacionComponente';
import { useAuthStore } from '@/store/auth';
import { useColumnsInstalacionesOT } from '@/erp/tecnico/orden-trabajo/shared/hooks';
import { useFetchICommisions } from '@/shared/actions/erp/comision/comisiones.actions';

const InstalacionRealizadaPage = () => {

  const user = useAuthStore(s => s.user);
  const { data: dataComision, isLoading: isLoadingComision } = useFetchICommisions(
    {
      vendedor: user?.id.toString(),
    }
  );

  const { instalacionesActivacionRealizadaColumns } = useColumnsInstalacionesOT();

  useEffect(() => {
    if (!isLoadingComision) {
    }
  }, [dataComision, isLoadingComision]);

  if (isLoadingComision) return <LoaderComponent />;

  return (
    <SingleTableBoxScene title="Instalación Realizado">
      <Grid container spacing={1}>
        {!isLoadingComision &&
          dataComision?.data.data.map((value) => (
            <CardComisionComponente
              key={value.codigo}
              monto={value.total_ventas.toString()}
              tipo={'Plan - ' + value.codigo}
              total={value.total_ventas_numeros.toString()}
            />
          ))}

        {dataComision?.data.count === 0 && (
          <Grid item xs={12}>
            <Typography>Aún no tienes ventas. Realiza algunas ventas para ver tus comisiones</Typography>
          </Grid>
        )}

        <Grid item {...gridSizeMdLg12}>
          <TablaInstalacionComponente
            columns={instalacionesActivacionRealizadaColumns as any}
            estadoInstalacion={EstadoOrdenTrabajoCodigoEnum.REALIZADO}
          />
        </Grid>
      </Grid>
    </SingleTableBoxScene>
  );
};

export default InstalacionRealizadaPage;
